import React from 'react';
import { Icon } from './components';

// Identité de la plateforme d’inscription, commune à la connexion et aux dossiers.
// `section` : rubrique affichée à côté du logo (par défaut, les échanges).
export default function PlatformHeader({ children, section = { label: 'Étudiants en échange', icon: 'globe' } }) {
  return <header className="ex-topbar">
    <div className="ex-brand">
      <img className="ex-brand-logo" src="/img/logo.png" alt="ICES · Institut catholique de Vendée" width="250" height="98" />
      <span className="ex-brand-title">Plateforme d’inscription<small>Espace administratif</small></span>
    </div>
    <div className="ex-topbar-section"><Icon name={section.icon} size={18} />{section.label}</div>
    {children}
  </header>;
}
